import Api from "../api/api";

export default async (body) => {
  return await Api.post("account-delete-request", body);
};
